import { useQuery } from '@tanstack/react-query';

import { validateReferralCode } from './service';

export const useValidateReferralCode = (code: string) => {
  return useQuery({
    queryKey: ['referral-validation', code],
    queryFn: () => validateReferralCode(code),
    enabled: false,
    // 검증 실패(본인 코드·미존재·비활성)는 재시도해도 결과가 같으므로 즉시 에러 노출
    retry: false,
  });
};
